import { getData, postData } from "../api/api";
import type { VpnProfileStatus } from "./adminVpnProfileService";

export type VpnConnectResult = {
  status: "CONNECTED" | "CODE_REQUIRED";
  challengeId?: string | null;
  /** The server's own message, e.g. "A verification code has been sent to j***@example.com". */
  prompt?: string | null;
  session?: VpnProfileStatus;
};

/** Callers (OTP dialog, profile screen) show errors themselves, so the global notice is skipped. */
const quiet = { skipGlobalErrorNotification: true };

/** VPN session actions any workspace user may take (e.g. completing a login that needs a code). */
export const vpnSessionService = {
  /** Starts connecting; the server may ask for a code (e.g. one it e-mails) before it completes. */
  connect: (profileId: string) =>
    postData(`/api/vpn-sessions/${profileId}/connect`, {}, quiet) as Promise<VpnConnectResult>,
  answer: (profileId: string, challengeId: string, code: string) =>
    postData(`/api/vpn-sessions/${profileId}/challenge/${challengeId}`, { code }, quiet) as Promise<VpnConnectResult>,
  cancel: (profileId: string) => postData(`/api/vpn-sessions/${profileId}/cancel`, {}, quiet),
  status: (profileId: string) => getData(`/api/vpn-sessions/${profileId}/status`) as Promise<VpnProfileStatus>,
};
